/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Stat_First_CallsInputs */

const en_landing_preview_stat_first_calls = /** @type {(inputs: Landing_Preview_Stat_First_CallsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First calls`)
};

/**
* | output |
* | --- |
* | "First calls" |
*
* @param {Landing_Preview_Stat_First_CallsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_stat_first_calls = /** @type {((inputs?: Landing_Preview_Stat_First_CallsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Stat_First_CallsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_stat_first_calls(inputs)
});